import Swal from 'sweetalert2'

export default function showAlert(title:string, message:string, msgType:any, buttonText :string) {

    let alertData;
    if (buttonText) {
        alertData = {
            title: title,
            text: message,
            icon: msgType,
            confirmButtonText: buttonText,
            timer: 400000000
            
        };
    } else {
        alertData = {
            title: title,
            text: message,
            icon: msgType,
            timer: 400000000
        };
    }
    Swal.fire(alertData);
}


export const conformationAlert = async(message: string, alertTypeIcon: any, actionType: string) => {
    let flag = false;
    let confirmButtonText = actionType === 'delete' ? 'Yes! Delete' : 'Yes! Update';
    await Swal.fire({
        title: message,
        html: "<strong>Do you want to " + message + "</strong>",
        icon: "error",
        showCancelButton: true,
        cancelButtonText: 'No! Close',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmButtonText,
        confirmButtonColor: actionType === 'delete' ? '#d33' : '#50cd89'
    }).then((result) => {
        if (result.isConfirmed) {
            flag = true;
        }else{
            flag = false;
        }
    })
    return flag;
}

export const conformationAlert1 = async(message: string, alertTypeIcon: any, actionType: string) => {
    let flag = false;
    let confirmButtonText = actionType === 'delete' ? 'Yes! Update' : 'Yes ! Update';
    await Swal.fire({
        title: message,
        html: "<strong>Do you want to " + message + "</strong>",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: 'No! Close',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmButtonText,
        confirmButtonColor: actionType === 'delete' ? '#d33' : '#50cd89'
    }).then((result) => {
        if (result.isConfirmed) {
            flag = true;
        }else{
            flag = false;
        }
    })
    return flag;
}

export const conformationAlert2 = async(message: string, alertTypeIcon: any, actionType: string) => {
    let flag = false;
    let confirmButtonText = actionType === 'delete' ? 'Yes! Update' : 'Yes ! Update';
    await Swal.fire({
        title: message,
        html: "<strong>Do you want to " + message + "</strong>",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: 'No! Close',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmButtonText,
        confirmButtonColor: actionType === 'delete' ? '#d33' : '#50cd89'
    }).then((result) => {
        if (result.isConfirmed) {
            flag = true;
        }else{
            flag = false;
        }
    })
    return flag;
}